import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ElectricalSidebar from './ElectricalSidebar';
import mcc1 from '../../img/Motor Control Panel/mcc1.jpg';
import mcc2 from '../../img/Motor Control Panel/mcc2.jpg'

function MCCPanel() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 bg-light mt-5" id="mcc-panel">
      <div className="container">
        <div className="row">
          {/* Main Content */}
          <div className="col-lg-9 col-md-8 mb-4">
            {/* Title */}
            <div className="text-center mb-4" data-aos="fade-up">
              <h2 className="fw-bold">⚙️ MCC Panel (Motor Control Center)</h2>
              <p className="text-muted">
                Efficient motor control systems for industrial automation and safety.
              </p>
              <p className="text-muted fw-semibold">MCC Panel &nbsp; | &nbsp; Electric Low Voltage Panel</p>
            </div>

            {/* Application */}
            <div className="mb-4" data-aos="fade-up">
              <p className="text-muted lead">
                MCC panels are used to control and protect electric motors in industrial and commercial facilities. Commonly installed in manufacturing plants, water treatment plants, HVAC systems, and process industries, they centralize motor operations, reduce downtime, and enhance operational safety.
              </p>
            </div>

            {/* Images */}
            <div className="row mb-4" data-aos="zoom-in">
              <div className="col-md-6 mb-3">
                <img
                  src={mcc1}
                  alt="MCC Panel"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6 mb-3">
                <img
                  src={mcc2}
                  alt="Motor Control Center"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
            </div>

            {/* Ratings */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-primary">📏 Ratings</h4>
              <ul className="text-muted">
                <li><strong>Voltage:</strong> 415V, 3-phase, 50Hz</li>
                <li><strong>Current:</strong> Up to 6300A</li>
                <li><strong>Short Circuit Rating:</strong> Up to 100kA for 1 sec</li>
                <li><strong>Starter Types:</strong> DOL, Star-Delta, Soft Starter, VFD</li>
              </ul>
            </div>

            {/* IEC Standards */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-info">📘 IEC Standards</h4>
              <ul className="text-muted">
                <li><strong>IEC 61439-1 & 2</strong> – Low-voltage switchgear assemblies</li>
              </ul>
            </div>

            {/* Key Features */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-success">✨ Key Features</h4>
              <ul className="text-muted">
                <li>Types: DOL, Star-Delta, VFD, Soft Starter panels</li>
                <li>Thermal overload and short circuit protection</li>
                <li>Manual/Auto mode with remote-control support</li>
                <li>IP-rated enclosures for dust and moisture resistance</li>
                <li>Expandable modular sections for future upgrades</li>
              </ul>
            </div>

            {/* Benefits */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-success">Benefits</h4>
              <ul className="text-muted">
                <li><strong>Centralized Motor Control:</strong> Efficiently manages multiple motors in one panel.</li>
                <li><strong>Enhanced Safety:</strong> Reduces risk of damage and increases operator safety.</li>
                <li><strong>Energy Optimization:</strong> VFDs help reduce electricity usage and cost.</li>
                <li><strong>Real-Time Monitoring:</strong> Built-in diagnostics improve performance and maintenance.</li>
              </ul>
            </div>

            {/* Applications */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-info">Applications</h4>
              <ul className="text-muted">
                <li><strong>Industrial Plants:</strong> Controls conveyors, fans, and compressors in factories.</li>
                <li><strong>Water Treatment:</strong> Essential for pumps and mixers in treatment processes.</li>
                <li><strong>HVAC Systems:</strong> Regulates motors in fans, chillers, and compressors.</li>
              </ul>
            </div>

            {/* Call to Action */}
            <div
              className="p-4 bg-white border-start border-4 border-primary rounded shadow-sm"
              data-aos="fade-up"
            >
              <h5 className="text-dark fw-semibold">Need MCC Panels for Your Industry?</h5>
              <p className="mb-2 text-muted">
                We design and supply custom MCC solutions for reliable motor operation.
              </p>
              <a
                href="/contact"
                className="btn"
                style={{
                  backgroundColor: '#08717A',
                  color: '#fff',
                  border: 'none',
                }}
              >
                Contact Us
              </a>
            </div>
          </div>

          {/* Sidebar */}
          <ElectricalSidebar />
        </div>
      </div>
    </section>
  );
}

export default MCCPanel;
